import { facadeApi } from 'api'
import { HostInfo } from 'types/tenants/tenant'

export const fetchHostInfoApi = () => facadeApi.get<HostInfo>('/host-info')
